<template>
  <v-container class="py-10" id="zukunftstechnologienNutzen">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#0391af">Chancen</div>
        <h2>Nutzung von Zukunftstechnologien</h2>
        <p>
          Die oben genannten Technologien werden von den befragten
          Organisationen nur wenig genutzt. Nur <b>34 %</b> der Organisationen
          gaben an, mindestens eine der Technologien zu nutzen. Von den
          genannten Technologien wird am häufigsten Cloud-Technologie
          eingesetzt.
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'Zukunftstechnologien Nutzung' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UseFutureTech",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "item",
          height: "50%"
        },

        title: {
          text: "Nutzung von Zukunftstechnologien"
        },

        legend: {
          labelFormat: '{name} <span style="opacity: 0.4">{y} %</span>'
        },

        series: [
          {
            name: "Prozent",
            keys: ["name", "y", "color", "label"],
            layout: "vertical",
            data: [
              [
                "Nutzen Zukunftstechnologien",
                34.0,
                "#005a85",
                "Nutzen Zukunftstechnologien"
              ],
              [
                "Nutzen keine Zukunftstechnologien",
                66.0,
                "#444",
                "Nutzen keine Zukunftstechnologien"
              ]
            ],
            dataLabels: {
              enabled: true,
              format: "{point.label} %"
            }
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Zukuntfstechnologien_Nutzung",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
